import type { FC } from 'react';
import c from 'classnames';
import Heading, {
  type HeadingProps,
} from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './StudioHeading.scss';

interface Props extends HeadingProps {}

const StudioHeading: FC<Props> = ({ className, ...rest }) => {
  return <Heading className={c(s['root'], className)} {...rest} />;
};

StudioHeading.displayName = 'StudioHeading';

export default StudioHeading;
